<template>
  <div class="filter-box">
    <div :class="['heading', { active }]" @click="action">
      <div class="sizer">
        <slot name="icon"></slot>

        <div class="title">
          {{ caption }}

          <span v-if="baseline" class="baseline">{{ baseline }}</span>
        </div>
      </div>

      <div v-if="$slots.active" class="main-icon-arrow">
        <slot name="active" />
      </div>

      <i v-else :class="active ? 'icon-visible' : 'icon-not_visible'" class="main-icon" />
    </div>

    <p v-if="description" class="description">{{ description }}</p>

    <slot name="body" />
  </div>
</template>

<script>
export default {
  props: ['caption', 'overrideActive', 'action', 'baseline', 'description'],

  computed: {
    active() {
      return this.overrideActive;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.filter-box {
  padding: 16px;
  border-bottom: 1px solid colors.$clear-border-color;

  .heading {
    color: colors.$nude-concrete-color;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.3s ease;

    .sizer {
      font-weight: 700;
      font-size: 14px;
      display: flex;
      align-items: center;

      .icon-pin {
        height: 40px;
        width: auto;
        margin-left: -0.25em;
        margin-right: 0.5em;
      }

      i {
        font-size: 1.2em;
      }

      .title {
        width: 100%;
      }

      .baseline {
        color: grey;
        font-size: 11px;
        font-weight: 400;
      }

      .material-icons {
        margin: 0 0.2em;
      }
    }

    .main-icon {
      font-size: 1.75em;
    }

    .main-icon-arrow {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.active {
      color: colors.$navy-color;
    }
  }

  .description {
    color: colors.$nude-concrete-color;
    font-size: 11px;
    font-style: italic;
    margin: 0;
  }

  label {
    font-size: 12px;
    line-height: 16px;
    cursor: pointer;
    user-select: none;
  }

  &.disabled {
    [type='radio']:not(:checked) + label:after,
    [type='radio']:checked + label:after {
      background-color: colors.$nude-concrete-color;
    }
    [type='radio']:checked + label:before {
      border-color: colors.$nude-concrete-color;
    }
  }
}
</style>
